import { queryOptions } from '@tanstack/react-query';

import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type DataUploadPresignedUrlResponse = {
	presignedUrl: string;
	expiresInSec: number;
};

export async function getDataUploadPresignedUrl(
	id: string,
	{ deleted = false }: { deleted?: boolean } = {},
): Promise<DataUploadPresignedUrlResponse | null> {
	const response = await axios.get(
		API_URLS.DATA_UPLOAD.PRESIGNED_URL(id),
		deleted ? { params: { deleted: true } } : undefined,
	);
	return getResponse<DataUploadPresignedUrlResponse>(response.data);
}

/** With `deleted`, a deleted file can still be viewed and downloaded (GH #331; it is kept in storage). */
export const getDataUploadPresignedUrlOptions = (
	id: string | null | undefined,
	{ deleted = false }: { deleted?: boolean } = {},
) =>
	queryOptions({
		queryKey: deleted ? ['data-uploads', 'presigned-url', id, 'deleted'] : ['data-uploads', 'presigned-url', id],
		queryFn: () => getDataUploadPresignedUrl(id as string, { deleted }),
		enabled: !!id,
		// Presigned URLs expire after 1 hour — refetch after 55 minutes to stay fresh.
		staleTime: ({ state }) => (state.data?.expiresInSec || 0) * 1000,
	});
